export default {
    "title": "Invoices / {{client}}",
    "description": "Invoices list with PDF download",
    "filters": {
        "invoiceNumber": "Invoice number"
    },
    "invoicesHeader": "<0>{{count}}</0> invoices for a total amount of € <0>{{total}}</0>",
    "invoicesTableColumns": {
        "date": "Invoice date",
        "document_id": "Invoice number",
        "base": "Base",
        "vat": "Taxes",
        "total": "Total"
    },
    "nameCollection": "invoices"
}